import { bind } from 'bind-decorator';
import { CacheUpdateEvent } from 'tm3-core/events/cache';

export interface IEvent {}
export interface IMapEvent<T> extends IEvent {}

class Mediator {
  _subs = new Map<string, Function[]>();

  @bind
  updateCache() {
    return this.publish(new CacheUpdateEvent());
  }
  @bind
  publish<T extends IEvent>(req: T) {
    // fire and forget
    return new Promise((resolve, reject) => {
      let evts = this._subs.get(req.constructor.name) || [];
      evts.forEach((fn) => fn(req));
      resolve();
    });
  }

  @bind
  map<R, T extends IMapEvent<R>>(req: T): Promise<R[]> {
    let evts = this._subs.get(req.constructor.name) || [];
    const promises = evts.map((fn) => fn(req));
    return promises;
  }

  @bind
  subscribe<T extends IEvent>(TCreator: { new (): T }, handler: (param: T) => void) {
    let example = new TCreator();
    let handlers = this._subs.get(example.constructor.name) || [];
    handlers.push(handler);
    this._subs.set(example.constructor.name, handlers);
  }

  @bind
  unsubscribe<T extends IEvent>(TCreator: { new (): T }, handler: (param: T) => void) {
    let example = new TCreator();
    let handlers = this._subs.get(example.constructor.name) || [];
    handlers.splice(handlers.indexOf(handler), 1);
    this._subs.set(example.constructor.name, handlers);
  }
}

export default Mediator;
